import React, { useCallback } from "react";
import { ButtonPrimary, GlobalSearchSeeAllTrips, ProductGrid, ProductGridItem, useProductGridImageSizes } from "@muchbetteradventures/styleguide";
import Hit from "./Hit";

var Hits = function Hits(_ref) {
  var hits = _ref.hits,
      renderPrice = _ref.renderPrice,
      searchResults = _ref.searchResults,
      _ref$searchState = _ref.searchState,
      searchState = _ref$searchState === void 0 ? {} : _ref$searchState,
      _ref$seeAllTripsHref = _ref.seeAllTripsHref,
      seeAllTripsHref = _ref$seeAllTripsHref === void 0 ? "/explore" : _ref$seeAllTripsHref,
      _ref$seeAllTripsLabel = _ref.seeAllTripsLabel,
      seeAllTripsLabel = _ref$seeAllTripsLabel === void 0 ? "See all trips" : _ref$seeAllTripsLabel,
      trackEvent = _ref.trackEvent;
  var imageSizes = useProductGridImageSizes(false);
  var handleProductCardClick = useCallback(function (e, hit, idx) {
    e.preventDefault();
    trackEvent("SERP Hit Click", {
      position: idx,
      searchState: searchState,
      hit: hit,
      nbHits: searchResults.nbHits
    }, hit.url);
  }, [searchState, searchResults, trackEvent]);
  var handleSeelAllTripsButtonClick = useCallback(function () {
    trackEvent("SERP See All Trips Click", {
      searchState: searchState,
      nbHits: searchResults.nbHits
    }, seeAllTripsHref);
  }, [seeAllTripsHref, searchState, searchResults, trackEvent]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, hits.length > 0 ? /*#__PURE__*/React.createElement(ProductGrid, null, hits.map(function (hit, index) {
    return /*#__PURE__*/React.createElement(ProductGridItem, {
      key: hit.objectID,
      fitAroundFilterSidebar: false
    }, /*#__PURE__*/React.createElement(Hit, {
      hit: hit,
      imageSizes: imageSizes,
      index: index,
      onClick: handleProductCardClick,
      renderPrice: renderPrice
    }));
  })) : null, !!searchState.query && /*#__PURE__*/React.createElement(GlobalSearchSeeAllTrips, {
    seeAllTripsText: "Can't find what you're looking for?",
    seeAllTripsButton: /*#__PURE__*/React.createElement(ButtonPrimary, {
      href: seeAllTripsHref,
      label: seeAllTripsLabel,
      onClick: handleSeelAllTripsButtonClick
    })
  }));
};

export default Hits;